module.exports = __webpack_public_path__ + "img/txt.5f6154db.svg";